import { render } from "./HeroiconsOutlinePresentationChartBar.vue?vue&type=template&id=d1f1dd4a"
const script = {}

import exportComponent from "/Users/danielarabia/code/rea-nova/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlinePresentationChartBar.vue"]])

export default __exports__